import React from 'react'
import styled from 'styled-components'

const Wrap = styled.div`
	margin-left:-1.5rem;
	@media (max-width: 768px) and (orientation: landscape) {
       svg{
		width: "360.000000pt"; 
		height: "360.000000pt";
		margin-left:.8rem;
		margin-top: -5rem;
       }
    }

    @media (max-width: 360px) {
        svg {
       		width: 100%;
       		height: 20vh;
       		margin-left:-12rem;
			margin-top: 2rem;
        } 
    }
`

const Artwork = () => {
	return (
		<>
		<Wrap>
			<svg viewBox="0 0 526 543" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g transform="translate(0.000000,640.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
			<path d="M2100 5225 c-138 -28 -240 -83 -287 -155 -12 -19 -26 -38 -30 -42 -5
			-4 -26 -23 -48 -42 -60 -51 -80 -114 -79 -251 1 -178 42 -290 168 -459 37 -49
			68 -99 71 -110 2 -12 8 -49 14 -84 23 -145 147 -271 389 -397 40 -21 70 -40
			68 -43 -8 -7 -106 17 -145 37 -59 31 -152 113 -230 205 -71 84 -71 84 -108 76
			-46 -11 -79 -35 -120 -89 -69 -89 -24 -97 69 -11 l65 59 7 -70 c13 -144 59
			-202 276 -349 145 -98 280 -227 332 -316 71 -122 143 -335 199 -589 15 -71 25
			-132 22 -135 -3 -3 -8 1 -11 9 -6 17 -334 507 -451 675 -81 115 -84 122 -94
			195 -5 42 -11 81 -13 88 -2 8 -25 5 -81 -12 -43 -14 -85 -25 -93 -25 -35 0
			-143 143 -220 293 -19 37 -41 67 -49 67 -24 0 -116 -77 -224 -188 -56 -59
			-126 -129 -154 -155 -65 -60 -73 -86 -73 -252 l-1 -130 -48 120 c-88 222 -132
			284 -239 333 -103 47 -254 26 -369 -52 -61 -41 -161 -146 -183 -191 -25 -52
			-27 -203 -4 -326 67 -363 307 -1053 530 -1528 30 -63 54 -114 54 -115 0 -1
			-28 -1 -62 -1 -698 -2 -938 -6 -938 -16 0 -7 151 -10 508 -8 l508 2 46 -27
			c60 -35 133 -46 236 -36 146 15 233 43 209 67 -15 14 -113 22 -292 22 l-191 1
			-26 53 c-157 308 -400 953 -503 1332 -75 276 -96 486 -55 571 43 88 183 204
			291 239 64 22 172 21 224 0 59 -25 116 -76 152 -137 18 -29 62 -131 98 -227
			52 -135 71 -200 86 -295 66 -408 168 -818 278 -1113 37 -101 96 -221 124 -250
			25 -28 54 -30 62 -4 21 66 -133 576 -385 1276 l-83 230 -5 162 c-5 179 4 236
			44 274 28 27 29 24 8 -27 -23 -54 -13 -123 30 -215 19 -41 45 -115 57 -164 56
			-223 363 -719 601 -970 216 -229 308 -261 718 -252 129 3 300 12 380 21 152
			17 208 36 106 36 -77 0 -64 22 27 44 22 5 27 3 27 -13 0 -47 73 -47 148 -1 20
			12 50 20 77 20 44 0 46 -2 67 -44 13 -28 29 -46 42 -48 12 -2 386 9 831 24
			446 14 826 27 845 27 l35 1 132 253 c219 421 457 892 549 1087 93 200 91 196
			100 188 8 -9 -104 -249 -313 -671 -101 -203 -183 -373 -183 -378 0 -5 153 -9
			364 -9 l364 0 7 -28 c14 -67 201 -365 443 -711 68 -96 120 -176 117 -179 -9
			-9 -3083 -52 -3714 -52 -360 0 -383 1 -376 17 12 32 35 207 35 266 0 54 -1 57
			-25 57 -18 0 -38 -17 -78 -67 -83 -103 -199 -274 -192 -281 3 -4 56 -8 116
			-10 125 -5 124 -4 84 -89 l-24 -53 22 -12 c16 -8 396 -10 1572 -5 852 4 2024
			7 2603 7 792 0 1052 3 1052 12 0 8 -631 10 -2614 4 l-2615 -7 20 41 c11 22 22
			54 26 70 l6 30 481 1 c264 0 531 2 591 4 61 2 405 7 765 10 360 3 799 8 975
			11 176 3 546 9 823 13 276 5 505 11 508 13 3 3 -39 68 -94 144 -317 447 -501
			748 -486 796 5 17 -14 18 -365 18 l-371 0 199 398 c253 507 308 629 292 653
			-6 10 -11 29 -11 42 0 24 -65 64 -332 207 l-97 51 -19 -38 c-11 -21 -86 -182
			-167 -358 -168 -364 -180 -390 -317 -688 l-101 -217 63 -156 c96 -241 104
			-289 28 -160 -25 41 -71 132 -104 202 l-59 126 -74 -6 c-41 -3 -103 -6 -138
			-6 -46 0 -63 -4 -63 -13 0 -8 39 -99 86 -203 47 -104 89 -198 94 -209 8 -20 4
			-20 -310 -20 -254 0 -320 -3 -333 -14 -25 -20 -21 -29 21 -40 77 -22 662 -6
			670 18 4 11 241 7 315 -4 31 -5 14 -35 192 340 24 50 158 330 299 623 141 294
			256 540 256 548 0 8 -6 14 -13 14 -17 0 -246 114 -272 135 -20 16 -19 16 5 9
			31 -8 298 -139 323 -158 16 -12 14 -20 -27 -113 -81 -183 -675 -1353 -716
			-1411 -14 -21 -27 -22 -330 -33 -768 -26 -1372 -44 -1379 -39 -11 7 -31 46
			-31 59 0 6 8 11 19 11 10 0 34 11 53 24 31 20 54 25 180 34 152 11 200 25 283
			86 47 35 58 36 193 24 70 -6 145 -8 165 -4 43 8 59 33 33 51 -14 11 -6 14 50
			20 105 11 117 21 63 54 l-31 19 30 7 c45 10 63 34 55 78 -18 115 -359 257
			-586 245 -64 -3 -87 -11 -217 -72 -151 -71 -315 -140 -362 -151 -24 -6 -28 -4
			-28 13 0 12 -8 27 -19 34 -10 7 -22 29 -26 48 -4 19 -34 103 -67 185 -33 83
			-63 157 -66 165 -3 8 10 -5 28 -30 45 -63 91 -109 120 -124 31 -16 313 -5 472
			19 264 39 348 87 348 198 0 115 -84 394 -170 567 -54 108 -203 366 -262 453
			-36 53 -43 58 -66 52 -15 -4 -31 -7 -36 -8 -5 -1 -16 12 -24 28 -27 57 -189
			205 -223 205 -17 0 -159 142 -301 300 -103 114 -123 128 -197 137 -72 8 -120
			-4 -153 -39 l-28 -30 0 113 c-1 134 -20 256 -49 304 -11 20 -16 37 -10 40 17
			11 10 65 -15 113 -81 158 -215 223 -460 221 -67 0 -150 -7 -186 -14z m368 -20
			c115 -27 177 -70 241 -167 37 -54 55 -118 34 -118 -5 0 -28 16 -52 36 -97 76
			-292 144 -421 147 -61 1 -83 -3 -118 -21 -58 -31 -118 -86 -148 -137 -34 -60
			-52 -72 -114 -78 -71 -8 -100 -31 -129 -103 -21 -50 -25 -76 -25 -170 -1 -104
			1 -114 29 -169 42 -82 133 -143 175 -116 12 8 8 19 -22 63 -49 73 -58 92 -58
			127 0 80 31 80 103 1 29 -33 57 -60 60 -60 4 0 7 51 7 113 0 143 0 143 127
			149 81 4 96 7 119 29 24 23 26 29 22 104 -3 76 -2 80 19 83 11 2 90 -6 174
			-17 83 -12 174 -21 201 -21 48 0 49 -1 68 -43 34 -76 43 -177 37 -397 -7 -225
			-29 -380 -67 -467 -19 -46 -28 -55 -62 -65 -80 -24 -298 23 -458 99 -55 27
			-91 53 -135 99 -86 90 -151 99 -131 18 9 -34 77 -106 142 -149 121 -81 367
			-185 437 -185 65 -1 153 -57 230 -149 17 -20 -3 -3 -45 37 -42 39 -81 72 -88
			72 -7 0 -38 -27 -70 -60 -35 -36 -66 -60 -79 -60 -29 0 -233 106 -324 169
			-141 98 -208 193 -223 316 -8 73 -10 77 -90 182 -35 46 -75 105 -88 131 -108
			214 -94 508 28 566 20 9 36 26 40 40 3 13 28 44 55 69 54 47 135 83 236 103
			87 17 288 17 363 -1z m-50 -146 c42 -11 105 -33 140 -49 67 -31 152 -88 152
			-102 0 -13 -51 -10 -226 13 -89 12 -174 19 -188 15 l-26 -6 6 -83 c9 -110 0
			-118 -131 -126 -130 -8 -138 -16 -136 -141 l0 -92 -49 46 c-74 69 -120 59
			-120 -28 0 -42 14 -76 54 -133 16 -24 27 -46 24 -49 -3 -3 -24 4 -46 15 -105
			54 -146 196 -106 372 22 99 48 126 127 135 67 8 75 13 147 111 99 131 179 153
			378 102z m624 -569 c28 -8 59 -35 130 -113 51 -56 140 -150 197 -209 l105
			-108 -44 -37 c-58 -49 -112 -104 -132 -131 -13 -20 -19 -21 -44 -11 -16 6 -89
			17 -163 25 -74 8 -151 19 -172 24 -39 11 -99 69 -99 96 0 18 18 10 75 -36 22
			-18 58 -41 79 -52 38 -19 39 -19 63 -1 14 10 57 69 95 132 l70 113 -33 34 -33
			34 -41 -47 c-52 -59 -68 -52 -51 20 7 28 18 63 25 75 7 13 10 26 7 29 -3 4
			-45 -1 -93 -9 -49 -9 -90 -14 -92 -13 -2 2 21 27 50 54 l54 50 -45 2 c-67 2
			-95 12 -95 34 0 43 103 68 187 45z m-142 -95 l42 -7 -43 -44 c-56 -57 -46 -69
			47 -54 38 6 77 13 86 16 16 5 16 2 3 -36 -18 -51 -22 -117 -8 -131 15 -15 44
			2 80 46 l30 35 18 -20 c18 -20 18 -22 2 -53 -32 -58 -132 -201 -143 -204 -10
			-3 -30 9 -142 90 -75 53 -102 -5 -34 -73 46 -46 78 -56 253 -74 171 -18 184
			-23 192 -73 7 -41 59 -113 83 -113 31 0 7 81 -40 137 l-27 33 71 70 c39 39 82
			78 95 86 23 15 26 14 52 -6 67 -52 174 -164 169 -176 -3 -8 -66 -62 -141 -121
			-121 -96 -135 -110 -135 -138 0 -32 44 -130 99 -223 17 -29 31 -55 31 -58 0
			-3 -57 41 -126 98 -201 164 -287 229 -324 245 -19 9 -53 24 -75 34 -33 15
			-171 39 -222 39 -31 0 -8 -29 64 -80 114 -82 137 -104 130 -124 -4 -9 -20 -19
			-37 -23 -37 -7 -34 -24 6 -36 75 -22 103 -40 113 -71 19 -59 52 -389 65 -646
			6 -124 9 -131 -79 203 -132 500 -184 618 -342 768 -73 70 -108 88 -190 100
			-82 12 -222 66 -342 132 -108 59 -221 159 -221 195 0 38 29 25 96 -43 97 -99
			276 -178 463 -205 138 -21 198 -1 232 75 23 53 55 236 65 371 6 97 7 101 24
			84 10 -10 37 -21 60 -25z m-850 -605 c108 -109 171 -147 274 -165 l71 -12 -4
			-111 c-3 -97 -1 -112 13 -112 8 0 22 14 31 30 9 17 17 30 19 30 7 0 115 -196
			160 -290 25 -52 55 -131 66 -175 34 -135 127 -570 124 -577 -2 -3 -12 -4 -22
			-1 -14 3 -21 22 -30 82 -19 122 -76 344 -122 476 -98 279 -183 381 -485 584
			-161 108 -209 176 -221 312 l-7 74 44 -50 c24 -27 64 -70 89 -95z m1675 41 c3
			-5 1 -12 -5 -16 -5 -3 -10 -18 -10 -31 0 -34 19 -27 48 17 13 19 29 34 35 34
			14 0 136 -195 243 -388 153 -275 258 -635 211 -727 -37 -73 -246 -122 -596
			-140 -157 -7 -168 -7 -196 12 -42 28 -113 124 -180 246 -32 56 -61 102 -66
			102 -5 0 -4 -10 0 -22 5 -13 54 -134 109 -269 54 -135 102 -262 106 -283 l7
			-37 -33 6 c-46 7 -407 52 -498 61 l-75 8 88 13 c88 13 127 26 127 43 0 10
			-118 421 -158 550 -83 264 -157 445 -187 456 -33 13 -12 23 58 26 39 2 78 6
			86 8 32 11 113 -233 226 -675 76 -299 84 -325 96 -325 11 0 11 11 -22 440 -20
			267 -34 390 -50 452 -8 30 -18 40 -57 59 -60 28 -57 25 -38 45 29 28 15 56
			-54 107 -36 27 -76 58 -90 69 l-25 19 69 -5 c37 -3 84 -13 104 -23 33 -17 37
			-24 58 -103 34 -131 86 -254 107 -258 17 -3 18 1 12 30 -11 57 -57 191 -81
			240 -47 94 -39 90 176 -80 270 -214 324 -265 361 -337 34 -65 59 -84 59 -44 0
			32 -30 89 -56 105 -42 28 -204 322 -204 370 0 16 28 43 100 98 55 43 117 94
			137 115 41 42 49 46 58 32z m-1955 -189 c90 -160 163 -256 205 -272 12 -4 45
			2 87 16 37 13 71 24 76 24 4 0 13 -36 20 -80 11 -76 15 -84 85 -182 85 -118
			420 -620 461 -690 l27 -46 -93 -4 c-51 -3 -100 -8 -109 -12 -13 -6 -41 34
			-141 201 -69 114 -161 278 -205 363 -126 245 -203 360 -327 488 -39 41 -88 82
			-108 93 -50 26 -148 25 -207 -1 -24 -11 -46 -20 -49 -20 -11 0 111 121 168
			166 30 24 58 40 61 36 4 -4 26 -40 49 -80z m924 21 c27 -26 67 -70 89 -98 l40
			-50 -84 -3 c-69 -2 -91 1 -125 18 -47 23 -70 19 -121 -24 -16 -14 -33 -23 -36
			-19 -4 3 -12 -6 -18 -21 -21 -46 -28 -28 -26 64 l2 90 42 -6 c42 -6 44 -5 100
			54 65 69 63 69 137 -5z m3183 -126 c94 -50 184 -102 200 -115 38 -31 32 -28
			-158 66 -166 82 -208 97 -216 75 -8 -21 52 -63 179 -126 l126 -62 -107 -225
			c-59 -124 -162 -337 -228 -475 -66 -137 -177 -369 -247 -515 l-126 -265 -123
			7 c-67 3 -145 7 -173 7 l-51 1 -92 204 c-50 111 -91 208 -91 215 0 7 22 11 63
			11 34 0 86 3 114 6 l52 7 55 -115 c60 -130 125 -244 161 -285 18 -21 26 -25
			35 -16 16 15 -5 87 -81 275 l-60 147 112 243 c61 134 127 277 147 318 19 41
			53 116 76 165 23 50 89 192 146 317 58 126 107 228 110 228 3 0 82 -42 177
			-93z m-4144 -11 c45 -19 190 -174 264 -282 34 -50 109 -180 166 -290 57 -109
			149 -273 204 -364 134 -222 126 -204 112 -245 -10 -28 -10 -51 4 -132 10 -54
			18 -109 20 -123 1 -14 6 -24 12 -23 24 5 45 226 25 273 -7 17 -9 34 -6 38 14
			13 188 14 316 2 125 -11 367 -40 512 -61 l76 -11 21 -84 c22 -88 30 -297 12
			-308 -5 -4 -58 -14 -118 -25 -124 -21 -183 -43 -190 -70 -6 -23 -23 -26 -208
			-42 -189 -15 -488 -8 -583 15 -97 24 -194 89 -309 209 -255 267 -550 738 -613
			981 -12 44 -39 121 -61 172 -21 51 -39 109 -39 128 0 52 57 155 105 188 89 62
			206 85 278 54z m950 -73 c33 -35 61 -100 126 -288 51 -147 196 -637 203 -684
			4 -29 -17 -36 -121 -47 l-67 -6 -42 198 c-94 437 -120 511 -256 748 -25 44
			-45 81 -43 82 12 13 62 23 113 23 53 1 63 -2 87 -26z m-1260 -918 c103 -292
			202 -593 256 -779 43 -146 76 -304 67 -313 -11 -11 -45 29 -79 95 -96 184
			-229 643 -311 1072 -14 74 -29 146 -32 160 -16 73 23 -20 99 -235z m2920 -90
			c48 -14 116 -39 150 -56 69 -34 157 -90 157 -101 0 -3 -21 2 -47 12 -72 27
			-213 54 -225 42 -6 -6 -1 -15 14 -26 35 -25 174 -66 223 -66 84 0 63 -49 -25
			-58 -36 -3 -82 3 -146 19 -81 20 -120 22 -102 4 3 -3 57 -18 119 -34 63 -16
			128 -34 144 -41 l30 -13 -45 -9 c-25 -5 -102 -7 -172 -4 -71 2 -128 1 -128 -4
			0 -5 17 -12 38 -15 177 -28 210 -39 149 -50 -20 -4 -96 -2 -167 4 -143 13
			-133 15 -226 -47 -66 -44 -126 -59 -270 -67 l-120 -6 4 35 c6 50 -24 172 -56
			231 -23 42 -33 51 -62 56 l-35 6 27 11 c128 53 228 98 313 137 55 26 116 54
			135 62 53 21 214 10 323 -22z m-731 -239 c38 -46 77 -207 64 -260 -6 -24 -11
			-26 -60 -26 l-53 0 -31 109 c-18 61 -32 133 -32 161 l0 51 48 -7 c30 -4 53
			-14 64 -28z m-772 -613 c0 -45 -24 -218 -36 -255 -5 -16 -19 -18 -99 -18 -53
			0 -97 4 -100 10 -11 17 202 310 225 310 6 0 10 -21 10 -47z m-1400 -352 l45
			-7 -40 -13 c-22 -7 -95 -15 -163 -18 -101 -5 -130 -3 -167 11 -25 10 -45 22
			-45 27 0 11 304 11 370 0z"/>
			</g>
			</svg>
		</Wrap>
		</>
	)
}

export default Artwork